import React, { useState, useRef, useEffect } from "react";
import { COUNTRIESWITHFLAG } from "../../../util/constants";
import "./style.css";
export const InputWithLabel = ({
  error = false,
  label,
  onChange,
  value,
  type = "text",
  name,
  required = false,
  placeholder,
  extraClass = null,
  errorMessage = false,
  customLabel = false,
}) => {
  // const [selOPen, setSelOpt] = useState(false)
  const ref = useRef();
  const refChange = useRef(onChange);
  const [initialRef, setInitialRef] = useState(true);
  const [flagVal, setFlagVal] = useState("355");
  const [showOpt, setShowOpt] = useState(false);

  const flags = COUNTRIESWITHFLAG;

  const [flagsShow, setFlagsSow] = useState(flags);

  const handleFilter = (e) => {
    const filteredFlags = flags.filter((el) =>
      el.name.toLowerCase().includes(e.target.value)
    );
    setFlagsSow(filteredFlags);
  };
  const handleOptionSelect = (c) => {
    setShowOpt(false);
    setFlagVal(c);
  };

  const handChan = (ev) => {
    onChange(name)({ ...ev, target: { value: ev.target.value, phc: flagVal } });
  };

  useEffect(() => {
    onChange(name)({ target: { value: value, phc: flagVal } });
  }, [flagVal]);
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (showOpt && ref.current && !ref.current.contains(e.target)) {
        setShowOpt(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [showOpt]);
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0
  let yyyy = today.getFullYear();
  today = yyyy + "-" + mm + "-" + dd;

  return (
    <div className="form" style={{}}>
      <div className={`form-item ${extraClass != null ? extraClass : ""}`}>
        {(name === "phoneNumber" || name === "otherNumber") && (
          <>
            <div
              className="select"
              onBlur={() => setShowOpt(false)}
              onClick={() => setShowOpt((prev) => !prev)}
            >
              + {flagVal}
            </div>
            {showOpt && (
              <div className="selectOptions" ref={ref}>
                <input className="selectInput" onChange={handleFilter} />
                {/* (name) */}
                <div className="selectOptDiv">
                  {flagsShow.map((fv) => (
                    <div
                      className="selOpt"
                      value={fv.value}
                      onClick={() => {
                        handleOptionSelect(fv.phonecode);
                      }}
                    >
                      <span className="sp1">
                        <img src={fv.flag} />
                      </span>
                      <span className="sp2">+{fv.phonecode}</span>{" "}
                      <span className="sp3">{fv.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
        <input
          type={type}
          id="input-field"
          required={required}
          className={error ? "error" : ""}
          onChange={handChan}
          value={value}
          placeholder={placeholder}
          maxLength={
            (label === "Phone Number" ||
              label === "971XXXXXXXXXX" ||
              label === "Other Number") &&
            "13"
          }
          max={type === "date" ? today : undefined}
        />
        <label htmlFor="password">
          {label}
          {required && " *"}
        </label>
      </div>
      <span style={{ fontSize: "0.65vw", paddingLeft: 10, color: "red" }}>
        {errorMessage}
      </span>
    </div>
  );
};

{
  /* <select class="country-id2 js-example-basic-single" name="id" onChange={(e) => {setFlagVal((e.target.value).toString())}} value={flagVal}>  */
}

{
  /* onClick={()=>{setSelOpt(prev => !prev)}}  */
}
// <option src="https://discoveritech.com/border-pay/public/assets/images/countries/AFG.png" value="93" data-select2-idd="select2-data-5-gecb">
{
  /* + 93 { selOPen ? "AFGHANISTAN " : ""} */
}
// + 93 AFGHANISTAN
// </option>
// <option src="https://discoveritech.com/border-pay/public/assets/images/countries/ALB.png" value="355" data-select2-idd="select2-data-12-60m7">
{
  /* + 355 { selOPen ?  "ALBANIA " : ""} */
}
// + 355 ALBANIA
// </option>
// <option src="https://discoveritech.com/border-pay/public/assets/images/countries/DZA.png" value="213" data-select2-idd="select2-data-13-ddyn">
{
  /* + 213 { selOPen ? "ALBANIA " : ""} */
}
//  + 213 ALBANIA

// </option>
// </select>
